export default __webpack_public_path__ + "static/dodies-ca341016d956cd0f3317cf2ffe74f409.png";